import styled from "styled-components";

import { Link } from "react-router-dom";

import MaskImage from 'assets/img/hexa-mask-2.png';

export const Container = styled.div``

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 50px;

  position: relative;

  .support__content-wrapper{
    width: 98%;
    max-width: 569.35px;
    height: fit-content;
    margin: 0 auto;
  }

  .support__content-title{
    width: 100%;
    font-size: 1.5625rem;
    line-height: 2rem;
    color: var(--blue00);
  }

  .support__content-button{
    width: calc(100% - 40px);
    max-width: 569.35px;
    height: 101.26px;

    display: flex;
    align-items: center;

    position: relative;
    left: 40px;

    text-decoration: none;
    background-color: var(--bluef0);
    border-radius: 9px;

    &:first-child{
      margin-top: 43.2px;
    }

    &:not(:first-child){
      margin-top: 28.7px;
    }
  }

  .support__content-icon-container{
    width: 116.32px;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    left: -40px;

    background-color: var(--blue00);

    mask-image: url(${MaskImage});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;

    > svg{
      height: 47%;
      width: auto;
      max-width: 47%;
    }
  }

  .support__content-button-text{
    height: fit-content;
    margin-left: 100px;

    display: inline;

    font-size: 1.1875rem;
    font-weight: bold;
    color: var(--blue00);
  }

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
  }
`

export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .support__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`
